// extracted by mini-css-extract-plugin
module.exports = {"container":"redirect_container__md09v","inner":"redirect_inner__7KJVn","header":"redirect_header__GckgB","timer":"redirect_timer__Veb1T","link":"redirect_link__4BNEa"};